export const invalidReferenceDate = Date.parse ('01 Jan 2020 00:00:00 GMT')
